/**
 * Whoever is signed in, read out of the collection everybody else is read from.
 *
 * `state.auth.id` is the only thing the client keeps about the current user -
 * one integer, put there by /users/me or by /login/. The row itself arrives with
 * /users/ inside the boot, like every other row in the application, and this is
 * the join.
 *
 * There used to be a second copy in `state.profile.entity`, fetched separately.
 * It went because a second copy goes stale: switching account changed
 * `account_id` on the server and refetched every collection, but not the
 * profile - so the header kept naming the previous customer until the page was
 * reloaded. Reading through the row instead means the switch fixes itself the
 * moment the row is replaced.
 *
 * `{}` when the collection has not arrived yet. Nothing renders before the boot
 * barrier resolves - App.js shows a Loader while `booting` - so screens never
 * see it; it is the login screen and the first paint that would.
 */
export const currentUser = state => state.users.models[state.auth.id] || {};

/** The account that user is sitting in, for the same reason and by the same route. */
export const currentAccount = state => state.accounts.models[currentUser(state).account_id] || {};
